import { formUtils } from '@insurancemenu/imenu-components-lib';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types';
import { PersonInfo, Subscriber } from 'types/electionService';
import { getElectionFormById } from 'api/operations/formService';
import { makeAutoObservable, runInAction, toJS } from 'mobx';
import { RootStore } from 'store/rootStore';
import { updateSubscriberInfo } from 'api/operations/electionService';
import { INITIAL_FORM_OBJECT } from './editPrimaryModalStore';

export default class ProductLineRateModalStore {
  rootStore: RootStore;
  loading = false;
  form: FormObjectFromJSON;
  isProductLineModalOpen = false;
  dynamicForm: null | formUtils.DynamicFormController;
  modalLoading = false;
  subscriber: Subscriber | null = null;

  public setModalLoading(loadingStatus: boolean): void {
    this.modalLoading = loadingStatus;
  }

  async openProductLineModal(subscriber: Subscriber, formId: string, productId: string): Promise<void> {
    this.isProductLineModalOpen = true;
    this.setModalLoading(true);
    this.dynamicForm = null;
    this.form = INITIAL_FORM_OBJECT;
    const carrierId = this.rootStore.domainStoreV2.domainHeader.id;
    const form = await getElectionFormById(formId, carrierId, subscriber.employeeClass, productId);
    runInAction(() => {
      this.subscriber = subscriber;
      this.form = form;
      this.createFormController({ ...subscriber.common });
      this.setModalLoading(false);
    });
  }

  closeProductLineModal(): void {
    this.isProductLineModalOpen = false;
    this.subscriber = null;
  }

  async updateSubscriberWithPLineFormAnswers(periodId: string, subscriber: Subscriber | null): Promise<void> {
    this.setModalLoading(true);
    if (!this.dynamicForm || !subscriber) return;

    const updatedSubscriber = { ...subscriber };
    const formFields = toJS(this.dynamicForm.getCanonicalAnswers());

    Object.entries(formFields).forEach(([key, value]) => {
      updatedSubscriber.common[key as keyof PersonInfo] = value?.toString() || '';
    });

    await updateSubscriberInfo(periodId, updatedSubscriber);
    runInAction(() => {
      this.setModalLoading(false);
      this.closeProductLineModal();
    });
  }

  createFormController(answers: Record<string, string>): void {
    this.setModalLoading(true);
    this.dynamicForm = new formUtils.DynamicFormController(this.form, this.rootStore.userStore.userRoles);
    this.dynamicForm.populateFields(answers);
    this.setModalLoading(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.dynamicForm = null;
    this.form = INITIAL_FORM_OBJECT;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
